var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.badge > 0)?_c('vs-chip',{staticClass:"number  text-white",attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.badge))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }